import React from 'react';

import { useAppSelector } from '../../../../redux/hooks';
import EmspInvoice from '../../../emsp-invoice';

/**
 * Component to display the invoice list in EV Device Hub
 * @returns The result
 */
function InvoiceList() {
  const { selectedEndConsumer } = useAppSelector((state) => state.endConsumerType);

  if (!selectedEndConsumer?.userCustomId) {
    return null;
  }

  return <EmspInvoice userCustomId={selectedEndConsumer.userCustomId} isComponent />;
}

export default InvoiceList;
